import restTypes from '../util/rest/types';
import restStates from '../util/rest/states';
import restInitState from '../util/rest/initState';

const initialState = {};
const facetInputTypesRestTypes = restTypes('facet_input_types');

export default (state = { ...restInitState, ...initialState }, action = {}) => {
  switch (action.type) {
    case facetInputTypesRestTypes.fetchAllStart:
      return {
        ...state,
        ...restStates.fetchAllStart,
      };
    case facetInputTypesRestTypes.fetchAllFinished:
      return {
        ...state,
        ...restStates.fetchAllFinished,
        ...action.payload,
      };
    default: return state;
  }
};
